export const ADD_TRENDING_SEARCH_SUCCESS = "ADD_TRENDING_SEARCH_SUCCESS";
export const CREATE_TRENDING_SEARCH_SUCCESS = "CREATE_TRENDING_SEARCH_SUCCESS";
export const LIST_ALL_TRENDING_SEARCHES_REQUEST = "LIST_ALL_TRENDING_SEARCHES_REQUEST";
export const LIST_ALL_TRENDING_SEARCHES_SUCCESS = "LIST_ALL_TRENDING_SEARCHES_REQUEST_SUCCESS";
export const LIST_ALL_TRENDING_SEARCHES_FAILURE = "LIST_ALL_TRENDING_SEARCHES_FAILURE";
export const UPDATE_TRENDING_SEARCH_SUCCESS = "UPDATE_TRENDING_SEARCH_SUCCESS";
export const DELETE_TRENDING_SEARCH_SUCCESS = "DELETE_TRENDING_SEARCH_SUCCESS";
